"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formatTimeSpan_1 = __importDefault(require("../formatTimeSpan"));
const formatTimeSpanAbbreviated = (endDate, startDate, addSuffix) => {
    return formatTimeSpan_1.default(endDate, startDate, addSuffix)
        .replace('year', 'yr')
        .replace('month', 'mo')
        .replace('week', 'wk')
        .replace('hour', 'hr')
        .replace('minute', 'min')
        .replace('second', 'sec');
};
exports.default = formatTimeSpanAbbreviated;
